export const width = 515;
export const height = 384;
export default __webpack_public_path__ + "static/fill-out-rafiki.54edb550.svg";